export interface CostColumn {
  key: string;
  label: string;
  align?: "left" | "right" | "center";
  flex?: number;
  readOnly?: boolean;
  endAdornment?: string;
  startAdornment?: string;
  placeholder?: string;
  type?: "text" | "checkbox" | "spacer";
}

export const MATERIAL_COLUMNS: CostColumn[] = [
  { key: "materialName", label: "Material Name", flex: 6 },
  { key: "percentage", label: "Percentage (%)", flex: 2, align: "right" },
  { key: "quantity", label: "Quantity", flex: 2, align: "right" },
  { key: "rate", label: "Rate", flex: 2, align: "right", startAdornment: "$" },
  { key: "cost", label: "Cost", flex: 2, align: "right", readOnly: true, startAdornment: "$" },
  { key: "__delete", label: "" },
];

export const EQUIPMENT_COLUMNS: CostColumn[] = [
  { key: "name", label: "Equipment Costs", flex: 4, readOnly: true },
  { key: "travelTime", label: "Travel Time", flex: 2, align: "right" },
  { key: "jobTime", label: "Job Time", flex: 2, align: "right" },
  { key: "quantity", label: "Quantity", flex: 2, align: "right" },
  { key: "rate", label: "Rate", flex: 2, align: "right", startAdornment: "$" },
  { key: "cost", label: "Cost", flex: 2, align: "right", readOnly: true },
  { key: "__delete", label: "" },
];

export const LABOR_COLUMNS: CostColumn[] = [
  { key: "name", label: "Labor Costs", flex: 4, readOnly: true },
  { key: "travelTime", label: "Travel Time", flex: 2, align: "right" },
  { key: "jobTime", label: "Job Time", flex: 2, align: "right" },
  { key: "quantity", label: "Quantity", flex: 2, align: "right" },
  { key: "rate", label: "Rate", flex: 2, align: "right", startAdornment: "$" },
  { key: "cost", label: "Cost", flex: 2, align: "right", readOnly: true },
  { key: "__delete", label: "" },
];

export const ADDITIONAL_COST_COLUMNS: CostColumn[] = [
  { key: "name", label: "Additional Costs", flex: 3, readOnly: true },
  { key: "showOnProposal", label: "Show", flex: 1, align: "center", type: "checkbox" },
  { key: "costType", label: "Cost Type", flex: 2, align: "right", readOnly: true },
  { key: "percentOrFee", label: "Percent/Fee", flex: 2, align: "right" },
  { key: "quantity", label: "Quantity", flex: 2, align: "right" },
  { key: "rate", label: "Rate", flex: 2, align: "right", startAdornment: "$" },
  { key: "cost", label: "Cost", flex: 2, align: "right", readOnly: true },
  { key: "__delete", label: "" },
];
